import { ref, computed } from '@nuxtjs/composition-api';

const activePromotion = ref(null);

export default function usePromotionsDrawer() {
  const openPromotionsDrawer = (promotion) => {
    activePromotion.value = promotion;
  };

  const closePromotionsDrawer = () => {
    activePromotion.value = null;
  };

  return {
    isPromotionsDrawerOpen: computed(() => Boolean(activePromotion.value)),
    activePromotion,
    openPromotionsDrawer,
    closePromotionsDrawer
  };
}
